/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const getFields = (model) => {
    if (!model) {
        return;
    }
    const fields = {};
    if (!model?.fields) {
        return fields;
    }
    for (const field of model.fields) {
        const name = field.name;
        fields[name] = field;
    }
    return fields;
};
export const isList = (field) => {
    const settings = getFieldSettings(field);
    const list = settings?.list;
    return list === true;
};
export const hasValues = (field) => {
    const values = getFieldValues(field);
    return Array.isArray(values) && values.length > 0;
};
export const getFieldValues = (field) => {
    const values = field?.values;
    return values;
};
export const getFieldSettings = (field) => {
    const settings = field?.settings;
    return settings;
};
export const hasValue = (field) => {
    const values = getFieldValues(field);
    return Array.isArray(values) && values.length > 0;
};
export const getFirstItemFromField = (field) => {
    if (!field) {
        return;
    }
    const values = getFieldValues(field);
    return values[0];
};
export const getFirstValueFromField = (field) => {
    const firstValue = getFirstItemFromField(field);
    const value = firstValue?.value;
    return value;
};
export const getFirstSettingsFromField = (field) => {
    const firstValue = getFirstItemFromField(field);
    const settings = firstValue?.settings;
    return settings;
};

export const eventTypes = ["model.event", "model.meeting"];

export const isEventType = (model) => {
    const type = model?.type;
    const isEvent = eventTypes.includes(type);
    return isEvent;
};
export const isMatchType = (model,type) => {
    const model_type = model?.type;
    const isMatch = model_type === type;
    return isMatch;
};
